import React, { Component } from "react";
import { Provider } from "react-redux";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

import Login from "./features/Login";
import Home from "./features";
import AdminHome from "./features/Admin";
import SumUpCallback from "./features/SumUp";
import ContentMEP from "./components/ContentMEP";
import DashboardHelpNurse from "./components/DashboardHelpNurse";

import initStore from "./config/configureStore";
import { setAuthHeader } from "utils/setAuthHeader";

import "semantic-ui-css/semantic.min.css";
import DualScreen from "features/DualScreen";
import { useClearCache } from "react-clear-cache";
import { Button, Modal } from "semantic-ui-react";
import Changelog from "./features/Version/changelog.json";
import { withTranslation, Trans } from "react-i18next";

const Cache = () => {
	const { isLatestVersion, emptyCacheStorage } = useClearCache({
		duration: 300000,
	});
	const getLastMepContent = () => {
		const lastReleaseContent = Changelog.releases[0];
		return lastReleaseContent;
	};
	if (window.location.pathname !== "/dashboard")
		return (
			<Modal open={!isLatestVersion}>
				<Modal.Header>
					<Trans i18nKey="version.newVersion" />
				</Modal.Header>
				<Modal.Content>
					<Trans i18nKey="version.detailsVersion" />
					<ContentMEP release={getLastMepContent()} />
					<Trans i18nKey="version.thankToUpdate" />
				</Modal.Content>
				<Modal.Actions>
					<Button
						color="green"
						content={<Trans i18nKey="version.update" />}
						onClick={(e) => {
							e.preventDefault();
							localStorage.clear();
							emptyCacheStorage();
						}}
					/>
				</Modal.Actions>
			</Modal>
		);
	return <></>;
};

class App extends Component {
	constructor(props) {
		super(props);

		let { store, persistor } = initStore();

		this.state = {
			isReady: false,
			store: store,
			persistor: persistor,
		};
	}

	componentDidMount() {
		this.setState({ isReady: true });
		window.onbeforeunload = () => true;
	}

	componentDidUpdate() {
		window.onbeforeunload = () => true;
	}

	render() {
		if (!this.state.isReady) {
			return <div>&nbsp;</div>;
		}

		return (
			<div>
				<Cache />
				<Provider store={this.state.store}>
					<PersistGate 
						loading={null} 
						persistor={this.state.persistor}
						onBeforeLift={() => {
							const state = this.state.store.getState();
							const token = state?.user?.session?.token;
							if (token) {
								setAuthHeader(token, 'both');
							}
						}}
					>
						<BrowserRouter>
							<Switch>
								<Route path="/" exact component={Login} />
								<Route path="/home" component={Home} />
								<Route path="/admin" component={AdminHome} />
								<Route path="/sumup/callback" component={SumUpCallback} />
								<Route path="/dualscreen" component={DualScreen} />
								<Route path="/dashboard" component={DashboardHelpNurse} />
							</Switch>
						</BrowserRouter>
					</PersistGate>
				</Provider>
			</div>
		);
	}
}
export default withTranslation()(App);
